import { Component, input, output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListItem } from '@angular/material/list';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { ToPlainTextPipe } from '@eiq/shared/utils';

@Component({
  standalone: true,
  selector: 'empathy-list-item-button',
  templateUrl: 'list-item-button.component.html',
  styleUrls: ['./list-item-button.component.scss'],
  imports: [FontAwesomeModule, MatCheckboxModule, MatListItem, ToPlainTextPipe]
})
export class ListItemButtonComponent {
  text = input.required<string>();
  icon = input<IconProp>();
  active = input<boolean>();
  showCheckbox = input(false);
  checked = input(false);
  testId = input<string>();

  clicked = output<void>();
  checkedChange = output<boolean>();
}
